import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensPlacementsSearch from './Search/ScreensPlacementsList';
import ScreensPlacementsView from './View/ScreensPlacementsView';
import ScreensPlacementForm from './Form/ScreensPlacementForm';
import ScreensPlacementsExport from './ScreensPlacementsExport';

function ScreensPlacements() {
  return (
    <Routes>
      <Route
        path="/export"
        element={
          <RoutePrivate
            element={ScreensPlacementsExport}
            requiredPermission="placements.list"
          />
        }
      />
      <Route
        path="/create"
        element={
          <RoutePrivate
            exact
            element={ScreensPlacementForm}
            requiredPermission="placements.create"
          />
        }
      />
      <Route
        path="/list"
        element={
          <RoutePrivate
            exact
            element={ScreensPlacementsSearch}
            requiredPermission="placements.manage"
          />
        }
      />
      <Route
        path="/:id"
        element={
          <RoutePrivate
            exact
            element={ScreensPlacementsView}
            requiredPermission="placements.read"
          />
        }
      />
      <Route
        path="/:id/edit"
        element={
          <RoutePrivate
            exact
            element={ScreensPlacementForm}
            requiredPermission="placements.update"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/placements/list" />} />
    </Routes>
  );
}

export default ScreensPlacements;
